import React from 'react'
import type { MarketSelector } from '../../../../Config/Season/season'
import type { LeaderboardHeaderProps } from '../Leaderboard.types'
import {
  LeaderboardHeader as StyledLeaderboardHeader,
  LeaderboardTitle,
  LocationSelect,
  DropdownArrowIcon,
} from './LeaderboardHeader.styles'

export const LeaderboardHeader: React.FC<LeaderboardHeaderProps> = ({
  title,
  boardType,
  handleLocationChange,
  availableMarkets,
  selectedMarketName,
}) => {
  return (
    <StyledLeaderboardHeader>
      <LeaderboardTitle>{title}</LeaderboardTitle>
      {boardType === 'location' && handleLocationChange && availableMarkets && (
        <>
          <DropdownArrowIcon>⌄</DropdownArrowIcon>
          <LocationSelect
            value={selectedMarketName || ''}
            onChange={(e) => handleLocationChange(e.target.value)}
            aria-label={`Select location for ${title} leaderboard`}
          >
            {availableMarkets.map((market: MarketSelector) => (
              <option key={market.name} value={market.name}>
                {market.name}
              </option>
            ))}
          </LocationSelect>
        </>
      )}
    </StyledLeaderboardHeader>
  )
}
